export default "__VITE_ASSET__C$J7Hv3F__"